import { render } from "./EmptyText.vue?vue&type=template&id=3373a9cc"
import script from "./EmptyText.vue?vue&type=script&lang=js"
export * from "./EmptyText.vue?vue&type=script&lang=js"

import "./EmptyText.vue?vue&type=style&index=0&id=3373a9cc&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/EmptyText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3373a9cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3373a9cc', __exports__)) {
    api.reload('3373a9cc', __exports__)
  }
  
  module.hot.accept("./EmptyText.vue?vue&type=template&id=3373a9cc", () => {
    api.rerender('3373a9cc', render)
  })

}


export default __exports__